<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu"><nav-header :active-index="activeIndex"></nav-header></el-header>

    <el-main id="router_view">
      <el-row style="width: 100vw;height: 100vh;">

        <el-col :span=5 style="height: 98vh;font-family: 'Microsoft YaHei';border-right: solid 1px lightgray;font-size: 15px; overflow-y: scroll;" class="menuContainer">
          <el-menu
            style="background-color: white;height: 100vh; padding-bottom: 200px;"
            :default-active="default_active"
            class="el-menu-vertical-demo"
            @select="menuSelecked">

            <el-menu-item index="Introduction" class="cell_submenu"><i class="el-icon-document"></i><span>Introduction</span></el-menu-item>
            <el-menu-item index="EditorialCommittee" class="cell_submenu"><i class="el-icon-document"></i><span>Editorial Committee</span></el-menu-item>
            <el-menu-item index="SupportingInstitutions" class="cell_submenu"><i class="el-icon-document"></i><span>Supporting Institutions</span></el-menu-item>
            <el-menu-item index="TableOfContents" class="cell_submenu"><i class="el-icon-document"></i><span>Table of Contents</span></el-menu-item>

            <el-submenu class="css_menu" index="Method">
              <template slot="title"><i class="el-icon-document"></i><span>Methods</span></template>
              <el-menu-item index="TemperatureChanges" class="cell_submenu">Mapping Temperature Changes</el-menu-item>
              <el-menu-item index="GDPDistribution" class="cell_submenu">Mapping Global GDP Distribution</el-menu-item>

              <el-menu-item index="GDPExposureToDrought" class="cell_submenu_mrows">
                <p style="height: 50px;line-height: 25px;margin-top: 10px;">Mapping Global GDP Exposure <br/> To Drought</p>
              </el-menu-item>

              <el-menu-item index="GlobalCropDistribution" class="cell_submenu">Mapping Global Crop Distribution</el-menu-item>

              <el-menu-item index="GlobalCropExposureToExtremelyHighTemperature" class="cell_submenu_mrows" >
                <p style="height: 50px;line-height: 25px;margin-top: 10px;">Mapping Global Crop Exposure  <br/>  To Extremely High Temperature</p>
              </el-menu-item>

              <el-menu-item index="GlobalIndustrialValeAdded"  style="height: 70px;padding-top: 1px;">
                <p style="height: 50px;line-height: 25px;margin-top: 10px;">Mapping Global Industrial <br/> Vale Added</p>
              </el-menu-item>

              <el-menu-item index="GlobalRoadNetwork" class="cell_submenu" >Mapping Global Road Network</el-menu-item>

              <el-menu-item index="GlobalClimateChangeRiskOfHeatwaveMortality" class="cell_submenu_mrows">
                <p style="height: 50px;line-height: 25px;margin-top: 10px;">Mapping Global Climate Change  <br/>  Risk Of Heatwave Mortality</p>
              </el-menu-item>

              <el-menu-item index="GlobalMortalityRiskToRiverFloods"  style="height: 70px;padding-top: 1px;">
                <p style="height: 50px;line-height: 25px;margin-top: 10px;">  Mapping Global Mortality Risk <br/> To River Floods</p>
              </el-menu-item>

              <el-menu-item index="GlobalClimateChangeRiskOfCropYield" style="height: 70px;padding-top: 1px;">
               <p style="height: 50px;line-height: 25px;margin-top: 10px;"> Mapping Global Climate Change  <br/>  Risk Of Crop Yield</p>
              </el-menu-item>

              <el-menu-item index="RiceDistributionPrediction" class="cell_submenu" >Rice Distribution Prediction</el-menu-item>
              <el-menu-item index="GlobalGDPLossRiskToRiverFloods" class="cell_submenu_mrows" >Mapping Global GDP Loss Risk <br/> To River Floods</el-menu-item>
            </el-submenu>

          </el-menu>
        </el-col>

        <el-col :span="19">
<!--          <router-view style="background-color: #F3F5F6;height: 100vh"></router-view>-->
          <router-view style="background-color: white; height: 100vh"></router-view>
        </el-col>
      </el-row>
    </el-main>

  </el-container>
</template>

<script>

  import AppConfig from "./AppConfig";

  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  import NavHeader from "./components/NavHeader";
  export default {
    name: "About",
    components:{NavHeader},
    data(){
      return {
        bsd_logo,
        activeIndex: 'main',
        default_active:'Introduction',
      }
    },
    created() {
      this.loginUser = this.$appStorage.getUserMailbox();
    },
    methods:{
      menu_selected(index){
        console.log(index);
      },
      openOperationMenu(){
        window.open(AppConfig.minio_server+"/bun/Manual%20for%20the%20use%20of%20the%20global%20typical%20disaster%20risk%20digital%20mapping%20platform.docx","_blank");
      },

      menuSelecked(index){
        console.log(index);
        let router_path = '/BNUMap/main/'+index;
        this.$router.push({path:router_path})
      },
      /*******************************************************************************************************************
       * 导航条部分
       * */
      switchFeedback(){
        let userData = this.$appStorage.getUserData();
        if(userData==undefined){
          this.$router.push({path:'/BNUMap/Login'})
        }else {
          this.$router.push({path:'/BNUMap/Feedback'})
        }
      },

      Login(){
        let userData = this.$appStorage.getUserMailbox();
        if(userData==undefined){
          this.$router.push({path:'/BNUMap/Login'})
        }else {
          alert(userData);
        }
      },

      handleSelect(key, keyPath) {
        this.activeIndex = key;
        let rPath = "/BNUMap/"+key;
        this.$router.push({path:rPath})
      },

      loginOut() {
        this.$confirm('Do you want to log out?', 'Prompt', {
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          //清除缓存，修改登录状态
          this.$appStorage.userLogout();
          this.loginUser = this.$appStorage.getUserMailbox();
        })
      }

    },
    mounted() {


      //初始化操作
      this.menuSpan = 0;

    }


  }
</script>




<style scoped lang="scss">
  @import "BSDMap";


  .menuContainer{

  }
  .menuContainer::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }

  .cell_submenu{
    text-align: left;
    height: 50px;
  }
  .cell_submenu_mrows{
    text-align: left;
    height: 50px;
    line-height: 25px;
  }


  .css_menu{
    text-align: left;
  }
  .cl_row{
    margin-top: 10px;
  }
  .col_value{
    text-align: left;
    font-size: 2.5vh;
  }
  .col_point{
    width: 10px;height: 10px;border-radius: 5px;background-color: gray;
    margin-top: 1.0vh;
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About.vue